import React from 'react';
import '../navbar/Navbar.css';
import { FaRegBell, FaRegUser, FaChevronDown, FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo-back-dark.svg';
import { useAuth } from '../../context/AuthContext';
import ProfileMenu from '../navbar/ProfileMenu';

const AccountNavbar = () => {
  const [activeMenu, setActiveMenu] = React.useState(null);
  const [membershipData, setMembershipData] = React.useState(null);
  const profileRef = React.useRef(null);
  const { user, logout, ensureMembership } = useAuth();
  const navigate = useNavigate();

  // Effect para obtener la membresía
  React.useEffect(() => {
    if (!user?.email) {
      setMembershipData(null);
      return;
    }
    const fetchMembership = async () => {
        const res = await ensureMembership(user.email);
        setMembershipData(res);
    };

    fetchMembership();
  }, [user, ensureMembership]);

  // Effect para el click outside
  React.useEffect(() => {
    if (activeMenu === 'profile') {
      const handleClickOutside = (e) => {
        if (profileRef.current && !profileRef.current.contains(e.target)) {
          setActiveMenu(null);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [activeMenu]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar__logo-wrapper">
        <Link to="/dashboard">
          <img src={logo} alt="INVESCASA" className="navbar__logo-img" />
        </Link>
        <div className="navbar__divider" />
      </div>

      <div className="navbar__center-link" style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
        <FaArrowLeft style={{ fontSize: 18 }} />
        <Link to="/dashboard" style={{ color: 'white', textDecoration: 'none', fontSize: '1.1rem', fontWeight: 400 }}>
          Back to dashboards
        </Link>
      </div>

      <div className="navbar__icons">
        <FaRegBell className="navbar__icon" />
        <div
          className="navbar__profile-wrapper"
          onClick={() => setActiveMenu((prev) => (prev === 'profile' ? null : 'profile'))}
        >
          <FaRegUser className="navbar__icon" />
          <FaChevronDown className="navbar__arrow navbar__arrow--white" />
          {activeMenu === 'profile' && user && (
            <div ref={profileRef} className="navbar__dropdown-wrapper--login">
              <ProfileMenu user={user} member={membershipData} onLogout={handleLogout} />
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AccountNavbar;
